<template>
    <div>
        <div class="col-sm-12">
            <div :class="`${designForm?.template_default?.image_preview ? 'd-flex' : ''}`">
                <div class="col-9">
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 100px">{{ $t('landingPage.settingDesgin.fontSize') }} </label>
                        <div class="col-sm-8">
                            <Multiselect
                                :id="`select-font_page`"
                                :value.sync="designForm.font"
                                :options="listFontFamily"
                                :config="{ trackBy: 'id', label: 'name', error: false, isRemove: false }"
                                @select="handleSetStyleLP('fontFamily')"
                                @remove="handleSetStyleLP('fontFamily')"
                            />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 100px">{{ $t('landingPage.settingDesgin.squareType') }} </label>
                        <div class="col-sm-9">
                            <div class="d-flex">
                                <div v-for="item in listSquareType" :key="item.id + 's'">
                                    <InputRadio
                                        class="mr-4"
                                        :model.sync="designForm.border_radius_type"
                                        :name="`squareType`"
                                        :id="`squareType-${item.id}`"
                                        :value="item.id"
                                        :label="item.value"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 100px">{{ $t('landingPage.settingDesgin.PCBackgroundColor') }} </label>
                        <div class="col-sm-10">
                            <UploadImageCommon
                                :fileValues.sync="designForm.pc.background_image"
                                :id="`PCBackgroundImg`"
                                :config="{
                                    maxSize: 2048
                                }"
                            >
                                <template #warning>
                                    <div style="font-size: 13px">
                                        {{ $t('noteUploadMaxMB') }}
                                    </div>
                                </template>
                            </UploadImageCommon>
                            <div class="form-group row mt-2">
                                <label class="col-sm-1 text-nowrap" style="min-width: 50px">{{ $t('landingPage.backgroundText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="designForm.pc.background_color"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="designForm.pc.background_color"
                                            :config="{
                                                error: false
                                            }"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <InputCheckBox
                                    :model.sync="designForm.pc.is_repeat"
                                    :id="`check-repeat-background-PC`"
                                    :value="designForm.pc.is_repeat"
                                    :label="`repeat`"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 100px">{{ $t('landingPage.settingDesgin.SPBackgroundColor') }} </label>
                        <div class="col-sm-10">
                            <UploadImageCommon
                                :fileValues.sync="designForm.sp.background_image"
                                :id="`SPBackgroundImg`"
                                :config="{
                                    maxSize: 2048
                                }"
                            >
                                <template #warning>
                                    <div style="font-size: 13px">
                                        {{ $t('noteUploadMaxMB') }}
                                    </div>
                                </template>
                            </UploadImageCommon>
                            <div class="form-group row mt-2">
                                <label class="col-sm-1 text-nowrap" style="min-width: 50px">{{ $t('landingPage.backgroundText') }}</label>
                                <div class="col-sm-5">
                                    <div class="d-flex" style="gap: 1rem">
                                        <InputText
                                            style="min-width: 100px"
                                            :model.sync="designForm.sp.background_color"
                                            :config="{
                                                type: 'color',
                                                classCustom: 'form-control-color',
                                                error: false
                                            }"
                                        />
                                        <InputText
                                            style="max-width: 100px"
                                            :model.sync="designForm.sp.background_color"
                                            :config="{
                                                error: false
                                            }"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div>
                                <InputCheckBox
                                    :model.sync="designForm.sp.is_repeat"
                                    :id="`check-repeat-background-SP`"
                                    :value="designForm.sp.is_repeat"
                                    :label="`repeat`"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-sm-2 text-nowrap" style="min-width: 100px">{{ $t('landingPage.settingDesgin.templateDefault') }} </label>
                        <div class="col-sm-8">
                            <div class="d-flex flex-wrap" style="gap: 1rem">
                                <div v-for="item in listTemplateDefault" :key="item.id + 's'">
                                    <InputRadio
                                        class="mr-4"
                                        :model.sync="designForm.template_default"
                                        :name="`templateDefault`"
                                        :id="`templateDefault-${item.id}`"
                                        :value="item"
                                        :label="item.name"
                                        @change="handleSetStyleDefault"
                                    />
                                    <div class="mt-2" style="width: 100px; height: 80px">
                                        <img class="w-100 h-100" style="object-fit: cover" :src="item.image_preview" :alt="item.image_preview" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="designForm?.template_default?.image_preview" class="col-3" style="max-height: 620px; overflow-y: auto">
                    <div class="image--preview">
                        <img
                            class="w-100 h-100"
                            style="object-fit: cover"
                            :src="designForm?.template_default?.image_preview"
                            :alt="designForm?.template_default?.image_preview"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { InputRadio, InputText, InputCheckBox } from '@/components/Input';
import { LIST_FONT_PAGE, SQUARE_TYPE_PAGE } from '../../constants';
import { LIST_TEMPLATE_DEFAULT } from '../../styles';
import { onHandleSetAttr } from '../../handlers';
import { configFileds } from './constants';
import { landingPageMethods } from '@/state/helpers';
import { cloneDeep } from 'lodash';

import Multiselect from '@/components/Multiselect/main.vue';
import UploadImageCommon from '@/components/Uploads/Image/main.vue';

export default {
    name: 'SettingOverall',
    components: {
        Multiselect,
        InputRadio,
        InputText,
        UploadImageCommon,
        InputCheckBox
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    data() {
        return {
            listFontFamily: LIST_FONT_PAGE,
            listSquareType: SQUARE_TYPE_PAGE,
            listTemplateDefault: LIST_TEMPLATE_DEFAULT,
            configFileds: configFileds,
            designForm: cloneDeep(this.dataForm)
        };
    },
    methods: {
        ...landingPageMethods,

        handleSetStyleLP(type = null) {
            if (type === 'fontFamily') {
                this.handleSetStyleDefault(this.designForm.template_default);
            }
            onHandleSetAttr(this.designForm);
        },

        handleSetStyleDefault(evtStyle) {
            this.settingOverral({ default_tem: evtStyle, font_family: this.designForm.font });
        }
    },

    watch: {
        designForm: {
            handler(newDesignForm) {
                this.$emit('update:dataForm', newDesignForm);
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
